import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import {
  VERIFICATION_API_URL,
  VERIFICATION_AUTH_API_URL,
  VERIFICATION_AUTH_GUEST_SECRET,
} from '@system-dyg/features/verification/data-access';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(),
    provideRouter(appRoutes),
    { provide: VERIFICATION_API_URL, useValue: environment.verificationApiUrl },
    { provide: VERIFICATION_AUTH_API_URL, useValue: environment.authVerificationApiUrl },
    {
      provide: VERIFICATION_AUTH_GUEST_SECRET,
      useValue: environment.authVerificationGuestSecret,
    },
  ],
};
